module.exports = __webpack_public_path__ + "img/ICON_CROSSMEDIA.21eebfb6.png";